import { createApi } from '../client'

const api = createApi('/auth')

export default api
